export const DARK_PURPLE = '#2B3487';
export const LIGHT_PURPLE = '#6B71AB'
export const PALE_PURPLE = "#B5B8D5"
export const RED = '#9C3726'
export const DARK_GREEN = '#1c660d'
export const LIGHT_GRAY = "#f4f4f4"
export const DARK_GRAY = "#D9D9D9"